
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"29","viewBox":"0 0 21 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 14.5L18.0348 16.7044L20.423 14.5L18.0348 12.2956L16 14.5ZM0.96516 4.70441L13.9652 16.7044L18.0348 12.2956L5.03484 0.29559L0.96516 4.70441ZM13.9652 12.2956L0.96516 24.2956L5.03484 28.7044L18.0348 16.7044L13.9652 12.2956Z","fill":"#C1E8D4"}})])
          )
        }
      }
    